<template>
    <form
        @valid="clearErrors(), $emit('submit:valid')"
        @invalid="$emit('submit:invalid')"
        novalidate
        autocomplete="off"
        ref="form">
            <slot></slot>
    </form>
</template>
<script>
import { Validator } from '@nutshell/core';
import { computed } from 'vue'; 

export default {
    name:'form-container',
    emits: ['submit:valid', 'submit:invalid'],
    data() {
        return {
            validator: null,
            inputErrors: {},
            hasNewElements: false,
        }
    },
    watch: {
        hasNewElements(newValue) {
            if(newValue) {
                this.hasNewElements = false;
                this.reinitialize();
            }
        },
    },
    methods: {
        reset() {
            this.$refs.form.reset();
            this.reinitialize();
        },
        reinitialize() {
            const v = this.validator;
            v.update();
        },
        initialize( ) {
            this.validator = new Validator(this.$refs.form);
        },
        clearErrors() {
            this.inputErrors = {};
        },
        setErrors(errors) {
            this.inputErrors = errors;
        },
    },
	provide() {
		return {
            form: computed(() => ({
                inputErrors: this.inputErrors,
                hasNewElements: () => this.hasNewElements = true,
            })),
		};
	},
    mounted() {
        this.initialize();
    },
    updated() {
        this.reinitialize()
    }
}
</script>
